export const TICKET_WORK_POD_IDS = {
    SUMMARY: 'summary',
    ACTIONS: 'actions',
    TIMELINE: 'timeline',
    CHAT: 'chat',
    ASSETS: 'assets',
    PROCESSES: 'processes',
}

export const TICKET_WORK_POD_SIZES = {
    ONE_BY_ONE: '1x1',
    ONE_BY_TWO: '1x2',
    TWO_BY_ONE: '2x1',
    TWO_BY_TWO: '2x2',
}

export const TICKET_WORK_POD_SIZE_OPTIONS = [
    { value: TICKET_WORK_POD_SIZES.ONE_BY_ONE, label: '1 × 1' },
    { value: TICKET_WORK_POD_SIZES.ONE_BY_TWO, label: '1 × 2' },
    { value: TICKET_WORK_POD_SIZES.TWO_BY_ONE, label: '2 × 1' },
    { value: TICKET_WORK_POD_SIZES.TWO_BY_TWO, label: '2 × 2' },
]

export const TICKET_WORK_POD_SIZE_LABELS = TICKET_WORK_POD_SIZE_OPTIONS.reduce(
    (acc, option) => {
        acc[option.value] = option.label
        return acc
    },
    {}
)

export const TICKET_WORK_POD_DEFINITIONS = [
    {
        id: TICKET_WORK_POD_IDS.SUMMARY,
        title: 'AI Summary',
        description: 'AI summary guidance for the current ticket context.',
        drawerDescription:
            'Summary bullets and AI-generated context for the active ticket.',
    },
    {
        id: TICKET_WORK_POD_IDS.ACTIONS,
        title: 'Suggested Actions',
        description:
            'Ticket-scoped AI actions and pooled technician actions for this ticket.',
        drawerDescription:
            'Pending AI suggestions and pooled technician actions for the workspace.',
    },
    {
        id: TICKET_WORK_POD_IDS.TIMELINE,
        title: 'Shared Timeline',
        description:
            'Technician notes and accepted action history for this ticket.',
        drawerDescription:
            'Shared technician timeline entries and accepted action history.',
    },
    {
        id: TICKET_WORK_POD_IDS.CHAT,
        title: 'Ticket Chat',
        description: 'Persistent AI chat grounded to this ticket context.',
        drawerDescription:
            'Persistent AI chat grounded to the active ticket workspace.',
    },
    {
        id: TICKET_WORK_POD_IDS.ASSETS,
        title: 'Related Assets',
        description: 'Assets and knowledge context currently linked to this ticket.',
        drawerDescription:
            'Associated assets, documentation, and linked reference context.',
    },
    {
        id: TICKET_WORK_POD_IDS.PROCESSES,
        title: 'Linked Processes',
        description:
            'Hudu processes linked to this ticket, with live completion progress.',
        drawerDescription:
            'Linked Hudu processes and their current completion progress.',
    },
]

const DEFAULT_TICKET_WORK_POD_SIZE = TICKET_WORK_POD_SIZES.ONE_BY_ONE

const TICKET_WORK_POD_DEFINITION_MAP = TICKET_WORK_POD_DEFINITIONS.reduce(
    (acc, definition) => {
        acc[definition.id] = definition
        return acc
    },
    {}
)

const VALID_TICKET_WORK_POD_SIZES = new Set(
    TICKET_WORK_POD_SIZE_OPTIONS.map((option) => option.value)
)

const DEFAULT_TICKET_WORK_PODS = TICKET_WORK_POD_DEFINITIONS.map(
    ({ id }) => ({
        id,
        visible: true,
        size: DEFAULT_TICKET_WORK_POD_SIZE,
    })
)

export const getTicketWorkPodDefinition = (id) =>
    TICKET_WORK_POD_DEFINITION_MAP[id] || null

export const getDefaultTicketWorkPods = () =>
    DEFAULT_TICKET_WORK_PODS.map((pod) => ({ ...pod }))

export const normalizeTicketWorkPods = (pods) => {
    const incomingPods = Array.isArray(pods) ? pods : []
    const normalizedPods = []
    const seenIds = new Set()

    incomingPods.forEach((pod) => {
        const id = pod?.id
        const definition = getTicketWorkPodDefinition(id)

        if (!definition || seenIds.has(id)) {
            return
        }

        normalizedPods.push({
            id,
            visible:
                typeof pod.visible === 'boolean' ? pod.visible : true,
            size: VALID_TICKET_WORK_POD_SIZES.has(pod.size)
                ? pod.size
                : DEFAULT_TICKET_WORK_POD_SIZE,
        })
        seenIds.add(id)
    })

    DEFAULT_TICKET_WORK_PODS.forEach((defaultPod) => {
        if (!seenIds.has(defaultPod.id)) {
            normalizedPods.push({ ...defaultPod })
        }
    })

    return normalizedPods
}